/**
 * Soft/hard refetch must not replace a hydrated Internal Ask participant
 * list with []. That is how the sidebar shows "Participants (0)" after
 * create succeeds and Ask completion refetches.
 */
export function resolveParticipantsAfterServerMerge<T extends { length: number }>(
  current: T,
  incoming: T,
): T {
  if (incoming.length === 0 && current.length > 0) {
    return current;
  }
  return incoming;
}
